export default __webpack_public_path__ + "static/media/jaychou.4f490749.mp4";